import React from "react";

const Forbidden = () => {
  return (
    <h1
      style={{
        fontSize: "2rem",
        fontWeight: "bold",
        margin: "2rem",
        fontFamily: "Serif",
      }}
    >
      Access Forbidden!
    </h1>
  );
};

export default Forbidden;
